const POST_ENDPOINTS = {};
const GET_ENDPOINTS = {
  COUNTRIES: "dashboard/address/countries/",
  VERTICALS: "dashboard/signup/company/verticals/",
  REFERRAL_CODE: "referrals/link/",
  STATE_BY_COUNTRY: "dashboard/address/states/?country_code=",
  FEED: "/quizzes/?version=5",
  MODULE_INFO: "quizzes/details/?version=2&id=",
  SUGGESTED_BRANDS: "/following/suggested-vendors/",
  ACHIEVEMENTS: "achievements/",
  TEAM_LOCATIONS: "teams/location/?tm_id=",
  TEAM_ROLES: "companies/roles/?company_id=",
  TEAMS: "v2/teams/",
  ALL_SUBMISSIONS: "/submissions/history/",
  LAST_NUM_SUBMISSIONS: "/submissions/last_submissions/?submissions_number=",
  COMPLETIONS: "/submissions/",
  USER_DATA: "/users/",
  PROFILE: "/accounts/profile/",
  CERTIFICATION_DETAILS: "/certification/",
  AVAIL_TO_FOLLOW: "following/explore/",
  BRAND_DATA: "following/company-details/?id=",
  FOLLOWING: "following/",
  COMPLETION_DETAIL: "submissions/detail/?id=",
};

export { POST_ENDPOINTS, GET_ENDPOINTS };
